module.exports = __webpack_public_path__ + "static/media/3.733ff48d.png";